var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.35625 0 0 1.49167 0 3.33333C0 5.175 3.35625 6.66667 7.5 6.66667C11.6438 6.66667 15 5.175 15 3.33333C15 1.49167 11.6438 0 7.5 0ZM0 5V7.5C0 9.34167 3.35625 10.8333 7.5 10.8333C11.6438 10.8333 15 9.34167 15 7.5V5C15 6.84167 11.6438 8.33333 7.5 8.33333C3.35625 8.33333 0 6.84167 0 5ZM0 9.16667V11.6667C0 13.5083 3.35625 15 7.5 15C11.6438 15 15 13.5083 15 11.6667V9.16667C15 11.0083 11.6438 12.5 7.5 12.5C3.35625 12.5 0 11.0083 0 9.16667Z",
    fill: "#5196FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseIcon);
export default __webpack_public_path__ + "static/media/database_icon.c788ef5bf03bee996aeb55f48f37088c.svg";
export { ForwardRef as ReactComponent };